const spacing = {
  minWidth: "320px",
  maxWidth: "1347px",
  sideMargin: "8vw",
  sectionMargin: "calc(50px + 4vw)",
}

const colors = {
  black: "#000000",
  white: "#FFFFFF",
  grey: {
    700: "#616161",
    300: "#E0E0E0",
    200: "#EEEEEE",
    100: "#F5F5F5",
  },
  blue: "#8AEEF0",
  yellow: "#EEF08D",
}

const text = {
  color: colors.grey[700],
  size: "14px",
  weight: "normal",
  family: "Montserrat, sans-serif",
}

export default {
  spacing: spacing,
  colors: colors,
  text: text,
}
